import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import Cookies from 'js-cookie';
import { CART_UUID } from 'utility/constants/baskets';
import { useBasketAdmin, useMasquerade } from './useAuthenticated';

/** Standardize logout hook
 * signoutRedirect is _buggy_ with our settings
 */
export function useLogout() {
	const { signoutSilent } = useAuth();
	const isBasketAdmin = useBasketAdmin();
	const isMasquerade = useMasquerade();

	const logout = useCallback(async () => {
		// Prevent stealing a customers cart
		if (isBasketAdmin || isMasquerade) {
			Cookies.remove(CART_UUID);
		}
		await signoutSilent();
	}, [isBasketAdmin, isMasquerade, signoutSilent]);

	return logout;
}

export default useLogout;
